// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg width=\"200\" height=\"200\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"hex\" width=\"60\" height=\"52\" patternUnits=\"userSpaceOnUse\"><path d=\"M30 0 L60 15 L60 37 L30 52 L0 37 L0 15 Z\" fill=\"none\" stroke=\"rgba%28255,255,255,0.04%29\" stroke-width=\"1\"/></pattern></defs><rect width=\"200\" height=\"200\" fill=\"url%28%23hex%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   Crop Selector — Professional Dashboard
   ═══════════════════════════════════════════════════════════════ */

.crop-selector-container {
  min-height: 100vh;
  background: linear-gradient(160deg, #025c4f 0%, #247761 40%, #46b4a0 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px 32px;
  position: relative;
  overflow: hidden;
}

.crop-selector-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

/* ── Header ── */
.crop-selector-header {
  text-align: center;
  margin-bottom: 48px;
  position: relative;
  z-index: 1;
  animation: fadeInDown 0.6s ease-out;
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.crop-header-icon {
  font-size: 56px;
  margin-bottom: 16px;
  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.2));
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50%      { transform: translateY(-8px); }
}

.crop-selector-header h1 {
  color: #ffffff;
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 12px;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.crop-header-subtitle {
  color: rgba(255,255,255,0.85);
  font-size: 17px;
  margin: 0;
  max-width: 520px;
  line-height: 1.5;
}

/* ── Grid ── */
.crop-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 960px;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* ── Card ── */
.crop-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  position: relative;
  display: flex;
  flex-direction: column;
  animation: fadeInUp 0.5s ease-out both;
}

.crop-card:nth-child(1) { animation-delay: 0.05s; }
.crop-card:nth-child(2) { animation-delay: 0.10s; }
.crop-card:nth-child(3) { animation-delay: 0.15s; }
.crop-card:nth-child(4) { animation-delay: 0.20s; }
.crop-card:nth-child(5) { animation-delay: 0.25s; }
.crop-card:nth-child(6) { animation-delay: 0.30s; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.crop-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 48px rgba(0,0,0,0.2);
}

.crop-card:active {
  transform: translateY(-4px) scale(1.01);
}

/* Top accent bar */
.crop-card-accent {
  height: 5px;
  background: var(--crop-gradient);
  flex-shrink: 0;
}

/* Card body */
.crop-card-body {
  padding: 28px 24px 24px;
  text-align: center;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.crop-card-icon {
  font-size: 48px;
  margin-bottom: 14px;
  transition: transform 0.3s ease;
}

.crop-card:hover .crop-card-icon {
  transform: scale(1.15);
}

.crop-card-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
}

.crop-card-subtitle {
  margin: 0 0 16px;
  font-size: 13px;
  color: #888;
  font-style: italic;
}

.crop-card-stats {
  margin-top: auto;
}

.crop-stat-badge {
  display: inline-block;
  padding: 5px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  background: var(--crop-gradient);
  color: #ffffff;
  letter-spacing: 0.3px;
}

/* Arrow */
.crop-card-arrow {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 20px;
  color: #ccc;
  transition: all 0.3s ease;
  opacity: 0;
}

.crop-card:hover .crop-card-arrow {
  opacity: 1;
  color: var(--crop-color);
  transform: translateX(4px);
}

/* ── Loading ── */
.crop-loading {
  text-align: center;
  padding: 80px 20px;
  color: rgba(255,255,255,0.9);
}

.crop-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255,255,255,0.2);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ── Footer ── */
.crop-selector-footer {
  margin-top: 48px;
  position: relative;
  z-index: 1;
}

.crop-selector-footer p {
  color: rgba(255,255,255,0.5);
  font-size: 13px;
  margin: 0;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .crop-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  .crop-selector-header h1 {
    font-size: 28px;
  }
  .crop-card-body {
    padding: 20px 16px 18px;
  }
  .crop-card-icon {
    font-size: 36px;
  }
}

@media (max-width: 480px) {
  .crop-grid {
    grid-template-columns: 1fr;
    max-width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CropSelector.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE;EACE,iBAAiB;EACjB,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA+W;EAC/W,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,WAAW,2BAA2B,EAAE;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,sBAAsB,EAAE;AAClD,0BAA0B,sBAAsB,EAAE;;AAElD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gCAAgC;EAChC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   Crop Selector — Professional Dashboard\n   ═══════════════════════════════════════════════════════════════ */\n\n.crop-selector-container {\n  min-height: 100vh;\n  background: linear-gradient(160deg, #025c4f 0%, #247761 40%, #46b4a0 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 24px 32px;\n  position: relative;\n  overflow: hidden;\n}\n\n.crop-selector-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url('data:image/svg+xml,<svg width=\"200\" height=\"200\" xmlns=\"http://www.w3.org/2000/svg\"><defs><pattern id=\"hex\" width=\"60\" height=\"52\" patternUnits=\"userSpaceOnUse\"><path d=\"M30 0 L60 15 L60 37 L30 52 L0 37 L0 15 Z\" fill=\"none\" stroke=\"rgba(255,255,255,0.04)\" stroke-width=\"1\"/></pattern></defs><rect width=\"200\" height=\"200\" fill=\"url(%23hex)\"/></svg>');\n  pointer-events: none;\n}\n\n/* ── Header ── */\n.crop-selector-header {\n  text-align: center;\n  margin-bottom: 48px;\n  position: relative;\n  z-index: 1;\n  animation: fadeInDown 0.6s ease-out;\n}\n\n@keyframes fadeInDown {\n  from { opacity: 0; transform: translateY(-20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.crop-header-icon {\n  font-size: 56px;\n  margin-bottom: 16px;\n  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.2));\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50%      { transform: translateY(-8px); }\n}\n\n.crop-selector-header h1 {\n  color: #ffffff;\n  font-size: 36px;\n  font-weight: 700;\n  margin: 0 0 12px;\n  letter-spacing: -0.5px;\n  text-shadow: 0 2px 8px rgba(0,0,0,0.15);\n}\n\n.crop-header-subtitle {\n  color: rgba(255,255,255,0.85);\n  font-size: 17px;\n  margin: 0;\n  max-width: 520px;\n  line-height: 1.5;\n}\n\n/* ── Grid ── */\n.crop-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  max-width: 960px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n/* ── Card ── */\n.crop-card {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.12);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  animation: fadeInUp 0.5s ease-out both;\n}\n\n.crop-card:nth-child(1) { animation-delay: 0.05s; }\n.crop-card:nth-child(2) { animation-delay: 0.10s; }\n.crop-card:nth-child(3) { animation-delay: 0.15s; }\n.crop-card:nth-child(4) { animation-delay: 0.20s; }\n.crop-card:nth-child(5) { animation-delay: 0.25s; }\n.crop-card:nth-child(6) { animation-delay: 0.30s; }\n\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translateY(24px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.crop-card:hover {\n  transform: translateY(-8px) scale(1.02);\n  box-shadow: 0 16px 48px rgba(0,0,0,0.2);\n}\n\n.crop-card:active {\n  transform: translateY(-4px) scale(1.01);\n}\n\n/* Top accent bar */\n.crop-card-accent {\n  height: 5px;\n  background: var(--crop-gradient);\n  flex-shrink: 0;\n}\n\n/* Card body */\n.crop-card-body {\n  padding: 28px 24px 24px;\n  text-align: center;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.crop-card-icon {\n  font-size: 48px;\n  margin-bottom: 14px;\n  transition: transform 0.3s ease;\n}\n\n.crop-card:hover .crop-card-icon {\n  transform: scale(1.15);\n}\n\n.crop-card-title {\n  margin: 0 0 4px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.crop-card-subtitle {\n  margin: 0 0 16px;\n  font-size: 13px;\n  color: #888;\n  font-style: italic;\n}\n\n.crop-card-stats {\n  margin-top: auto;\n}\n\n.crop-stat-badge {\n  display: inline-block;\n  padding: 5px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--crop-gradient);\n  color: #ffffff;\n  letter-spacing: 0.3px;\n}\n\n/* Arrow */\n.crop-card-arrow {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 20px;\n  color: #ccc;\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n\n.crop-card:hover .crop-card-arrow {\n  opacity: 1;\n  color: var(--crop-color);\n  transform: translateX(4px);\n}\n\n/* ── Loading ── */\n.crop-loading {\n  text-align: center;\n  padding: 80px 20px;\n  color: rgba(255,255,255,0.9);\n}\n\n.crop-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(255,255,255,0.2);\n  border-top-color: #ffffff;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Footer ── */\n.crop-selector-footer {\n  margin-top: 48px;\n  position: relative;\n  z-index: 1;\n}\n\n.crop-selector-footer p {\n  color: rgba(255,255,255,0.5);\n  font-size: 13px;\n  margin: 0;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .crop-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n  .crop-selector-header h1 {\n    font-size: 28px;\n  }\n  .crop-card-body {\n    padding: 20px 16px 18px;\n  }\n  .crop-card-icon {\n    font-size: 36px;\n  }\n}\n\n@media (max-width: 480px) {\n  .crop-grid {\n    grid-template-columns: 1fr;\n    max-width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
